module.exports = __webpack_public_path__ + "static/media/icon_reservations_admin.2fd75d1b.svg";